<template>
  <v-container fluid grid-list-xs fill-height>
    <v-layout row wrap fill-height align-center text-md-left justify-center>
      <v-flex xs12 md6 lg7>
        <v-card flat class="transparent">
          <div
            :class="`${$vuetify.breakpoint.mdAndUp ?  'display-35' : 'display-15 mb-4 font-weight-light'}`"
            class="font-weight-regular"
          >Custom Real <br/> Estate Technology</div>
          <div
            :class="`${$vuetify.breakpoint.mdAndUp ?  'display-05 my-5' : 'subtitle-1 my-1'}`"
            class="font-weight-regular"
          >We help industry professionals drive growth through automation, insights, and unique customer experiences.</div>
          <div v-if="$vuetify.breakpoint.mdAndUp">
            <v-btn to="work" large outline color="primary" class="mr-2">See Our Work</v-btn>
          </div>
        </v-card>
      </v-flex>
      <v-flex xs10 md6 lg5>
        <v-img :src="require('../assets/images/iso-phone.png')"></v-img>
        <div v-if="!$vuetify.breakpoint.mdAndUp" class="text-xs-center">
          <v-btn to="work" large outline color="primary" class="mr-2">See Our Work</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {};
</script>

<style lang="css" scoped>
.display-15 {
  font-size: 2.5rem!important;
  line-height: 2.8rem
}
.display-35 {
  font-size: 5.3rem!important;
  line-height: 5.5rem
}
.display-05 {
  font-size: 2rem!important;
  line-height: 2.5rem
}
</style>
